module.exports = __webpack_public_path__ + "static/img/17.0c17c93d.jpg";